import { BaseRestDataProvider } from './BaseRestDataProvider';
import { DepreciationPeriod } from '../models/DepreciationPeriod';

export class DepreciationPeriodRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/depreciation-periods');
  }

  getAll(): Promise<DepreciationPeriod[]> {
    return this.get<DepreciationPeriod[]>(``);
  }

  getById(id: string): Promise<DepreciationPeriod> {
    return this.get<DepreciationPeriod>(`/${id}`);
  }

  add(period: DepreciationPeriod): Promise<DepreciationPeriod> {
    return this.post<DepreciationPeriod>(``, period);
  }

  update(id: string, period: DepreciationPeriod): Promise<void> {
    return this.put<void>(`/${id}`, period);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { DepreciationPeriod };

